import { render, staticRenderFns } from "./changeLPwdDc.vue?vue&type=template&id=22b0e5a3&scoped=true"
import script from "./changeLPwdDc.vue?vue&type=script&lang=js"
export * from "./changeLPwdDc.vue?vue&type=script&lang=js"
import style0 from "./changeLPwdDc.vue?vue&type=style&index=0&id=22b0e5a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b0e5a3",
  null
  
)

export default component.exports